import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUser, post, api, get, consts } from "@config";
import { setLoading } from "@inspinia-react/actions";
import { Button, FormControl, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import SweetAlert from "react-bootstrap-sweetalert";

import { setBasePersonName, setBasePersonEmail, setBasePersonPhoneNumber } from "@parts/base-person/actions";
import { setFancyName, setStateRegistry } from "@parts/company-data/actions";
import { setPersonDoc } from "@parts/document-component/actions";

import {
    setPostalCode,
    setStreetNumber,
    setComplement,
    setStateLocation,
    setCityLocation,
    setStreet,
    setDistrict,
} from "@parts/address-component/actions";

import { setCreateNewBranchStep } from "../steps/actions"


const fontStyle = {
    fontSize: 14,
    fontWeight: 300
}
const DEFAULT_DATA_COMPANY = {
    digital_certificate_info: {},
    sefaz_situation: {
        status: null,
        nfe_situation: {
            enabled_to_emit_nfe: null
        }
    },
    cnae: { code: '', description: '' },
    nfeInfo: { status: null, message: "" }
}
class ImportCertificate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: '',
            password: '',
            import: false,
            modalShowInfos: false,
            company: DEFAULT_DATA_COMPANY,
            modalDialog: false,
            modaInformation: false,
            modalSweetInformation: false,
            modalInforHeader: '',
            message: '',
            data: {},
            modalEditField: false,
            fieldInputValue: '',
            inputFieldName: '',
            branchImage: null
        }

        this.handleOpenFileChoose = this.handleOpenFileChoose.bind(this)
        this.validateFileSelected = this.validateFileSelected.bind(this)
        this.removeFileSelected = this.removeFileSelected.bind(this)
        this.tryUploadFile = this.tryUploadFile.bind(this)
        this.successPayload = this.successPayload.bind(this)
        this.openDialogCloseModal = this.openDialogCloseModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.setPassowrd = this.setPassowrd.bind(this)
        this.errors = this.errors.bind(this)
        this.uploadWithRegister = this.uploadWithRegister.bind(this)
        this.openModalEditFild = this.openModalEditFild.bind(this)
        this.changeField = this.changeField.bind(this)
        this.closeModalEditFild = this.closeModalEditFild.bind(this)
        this.saveModalEditFild = this.saveModalEditFild.bind(this)
        this.setDataInRedux = this.setDataInRedux.bind(this)
        this.setBrancImage = this.setBrancImage.bind(this)

    }
    handleOpenFileChoose() {
        document.querySelector('[name="digital_certificate"]').click()
    }
    validateFileSelected(e) {
        const file = e.target.files[0];
        const fileType = file.type;
        if (fileType !== "application/x-pkcs12") {
            //por algum motive ele consegiu colocar outro formato de aquivo...
            return;
        }
        this.setState({ ...this, file });
    }
    removeFileSelected() {
        this.setState({ ...this, file: null, password: '' })
    }
    openDialogCloseModal() {
        this.setState({ ...this, modalDialog: true })
    }
    closeModal() {
        this.setDataInRedux()
        this.setState({ ...this, company: DEFAULT_DATA_COMPANY, modalShowInfos: false, modalDialog: false })
        this.props.setCreateNewBranchStep(1)
    }
    openModalEditFild(key) {
        const fieldInputValue = this.state.company[key]
        this.setState({ ...this, fieldInputValue, modalEditField: true, inputFieldName: key })
    }
    changeField(e) {
        this.setState({ ...this, fieldInputValue: e.target.value })
    }
    closeModalEditFild() {
        this.setState({ ...this, inputFieldName: '', fieldInputValue: '', modalEditField: false })

    }
    saveModalEditFild() {
        const { company } = this.state
        company[this.state.inputFieldName] = this.state.fieldInputValue
        this.setState({ ...this, company, inputFieldName: '', fieldInputValue: '', modalEditField: false })

    }
    successPayload(data) {
        this.props.setLoading(false)
        if (data.postal_code === 0 && data.code === 100) {
            data["code"] = 998
            this.setState({ ...this, company: data })
            setTimeout(() => {
                this.errors(data)
            }, 120)
            return

        }
        if (data.code) {
            if (data.code > 200) {
                this.errors(data)
            }
            if (data.code === 100 && this.state.import) {
                const modalInforHeader = "Empresa Cadastrada com Sucesso!"
                this.setState({
                    ...this,
                    modalSweetInformation: true,
                    message: data.description,
                    modalInforHeader, modalShowInfos: false
                })
                const url = `${api.branches}${data.branch_id}/`

                const payload = branch => {
                    setTimeout(() => {
                        this.updateLocalStorage(branch)
                        window.location.href = "/plans/select"
                    }, 5000)
                }

                get(url, payload)

            }
        }
        const options = {
            year: "numeric",
            month: "long",
            weekday: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZone: 'America/Sao_Paulo'
        };
        const certificateExpireAt = new Date(data["digital_certificate_info"]["expire_at"]).toLocaleDateString("pt-br", options);
        const user = getUser()
        data["email"] = user.email
        data["phone_number"] = user.phone
        data["digital_certificate_info"] = {
            "expire_at": certificateExpireAt
        }
        this.setState({ ...this, company: data, modalShowInfos: true })

    }
    updateLocalStorage(branch) {
        window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(branch))
        window.localStorage.setItem(consts.ALL_BRANCHES, JSON.stringify([branch]))
        window.localStorage.setItem(consts.CERTIFICATES, JSON.stringify(branch.certificates))
        window.clientAPI._setCookie('branch_owner_id', branch.id)
        window.clientAPI._setCookie('branch_state_name', branch.address.state)
    }
    tryUploadFile() {
        if (!this.state.password) {
            document.getElementById("password-incorret").innerHTML = "Informe a senha do certificado"
            return
        }
        this.props.setLoading(true)
        const formData = new FormData();
        formData.append("password", this.state.password);
        formData.append("file", this.state.file);
        if (this.state.import) {
            formData.append("import_company", this.state.import);
            formData.append("company", JSON.stringify(this.state.company));
        }
        const url = `${api.certificates}get-info/`;

        post(url, formData, this.successPayload, this.errors);
    }
    uploadWithRegister() {
        const { fancy_name, email, phone_number } = this.state.company
        const errors = []
        if (!fancy_name) {
            errors.push("Nome fantasia")
        }
        if (!email) {
            errors.push("Email")
        }
        if (!phone_number) {
            errors.push("Telefone")
        }
        if (errors.length) {
            toast(`Por favor, corriga os erros. ${errors.join(", ")}`, { type: "error", toastId: 7789 })
            return
        }
        this.setState({ ...this, import: true })
        setTimeout(() => {
            this.tryUploadFile()
        }, 150)
    }
    setPassowrd(e) {
        const { value: password } = e.target
        this.setState({ ...this, password })
        document.getElementById("password-incorret").innerHTML = ""
    }
    errors(errors) {
        this.props.setLoading(false)
        if (errors.response) {
            errors = JSON.parse(errors.response)
            if (errors.password_error) {
                document.getElementById("password-incorret").innerHTML = "Senha incorreta"
            }
        } else if (errors.code) {
            let modalInforHeader = ""
            let message = ""
            if (errors.code === 999) {
                if (errors.import_error || errors.code > 200) {
                    modalInforHeader = "A importação falhou"
                    message = "Não foi possível importar a empresa"
                }
            } else if (errors.code === 998) {
                modalInforHeader = "Sem Endereço"
                message = "Não foi possível importar o endereço da empresa"
            } else if (errors.code === 265) {
                modalInforHeader = "Não foi possível importar os dados"
                message = "O seu estado não permite importação automática, click em OK para cadastro manual."
            }
            this.setState({
                ...this,
                modaInformation: true,
                message,
                modalInforHeader,
                modalDialog: false
            })
        }
    }

    setDataInRedux() {
        const data = this.state.company

        this.props.setBasePersonName(data.name || "")
        this.props.setBasePersonEmail(data.email || "")
        this.props.setBasePersonPhoneNumber(data.phone_number || "")

        this.props.setFancyName(data.fancy_name || "")
        this.props.setStateRegistry(data.state_registry || "")
        this.props.setPersonDoc(data.cnpj || "")

        this.props.setPostalCode(`${data.postal_code}` || "")
        this.props.setStreetNumber(data.street_number || "")
        this.props.setComplement(data.complement || "")
        this.props.setStateLocation({ value: data.state_id, label: data.state } || "")
        this.props.setCityLocation({ value: data.city_id, label: data.city } || "")
        this.props.setStreet(data.address || "")
        this.props.setDistrict(data.district || "")
        this.setState({ ...this, modalDialog: false })
    }

    setBrancImage(e) {
        if (e.target.files && e.target.files[0]) {
            this.setState({ ...this, branchImage: e.target.files[0] })
            var file = new FileReader();
            file.onload = function (e) {
                document.getElementById("preview").src = e.target.result;
            };
            file.readAsDataURL(e.target.files[0]);
        }
    }

    render() {
        return <div className="row mt-2 mx-auto">
            <div className="col-xs-12 col-md-6 col-lg-6 mx-auto " >
                <SweetAlert
                    success
                    title={this.state.modalInforHeader}
                    show={this.state.modalSweetInformation}
                    showConfirm={false}
                />
                <input
                    onChange={this.validateFileSelected}
                    type="file"
                    name="digital_certificate"
                    id=""
                    accept=".pfx"
                    style={{ display: "none" }} />
                <h2 style={{
                    color: "#3c4ce5",
                    fontWeight: 900
                }} className="text-center">
                    Vamos começar cadastrando sua empresa
                </h2>
                {/* <p className="lead">Clique no botão abaixo para importar os dados da sua empresa, caso você tenha um <strong>Certificado Digital</strong></p>
                <p className="text-center">
                <button style={{
                    padding: 15,
                    border: "none",
                    borderRadius: 20,
                    backgroundColor: "#3c4ce5",
                    color: "white",
                    fontSize: 19,
                    fontWeight: 500,
                    cursor: 'pointer'
                }} disabled={this.props.loading} className="mb-2" block onClick={this.handleOpenFileChoose}>
                    Preencher com Certificado Digital
                </button>
                </p> */}
                {
                    this.state.file ? <React.Fragment>
                        <span
                            className="badge badge-primary"> {this.state.file.name}
                        </span>
                        <i
                            title="Remover certificado"
                            onClick={this.removeFileSelected}
                            className="ml-3 fas fa-close"
                            style={{ cursor: "pointer" }}></i>

                        <div className="d-block p-0 mt-2">
                            <span>Informe a senha do certificado</span>
                        </div>
                        <input
                            onChange={this.setPassowrd}
                            id="certificate-password"
                            type="password"
                            placeholder="Senha"
                            disabled={this.props.loading}
                            className="mt-2 form-control" />
                        <div className="d-block m-0 p-0 mb-2">
                            <span id="password-incorret" className="text-danger"></span>
                        </div>
                        <Button
                            disabled={this.props.loading}
                            onClick={this.tryUploadFile}>
                            Importar empresa
                        </Button>
                    </React.Fragment> : null
                }
            </div>
            <Modal size="lg" show={this.state.modalShowInfos} onHide={this.openDialogCloseModal}>
                <Modal.Header closeButton className="">
                    <h3 className="d-block">Dados da empresa
                        <br />
                        <small>Clique em <strong><i className="fas fa-edit"></i></strong> para editar</small>
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <p className="lead">
                        Confirme os dados da empresa
                    </p>
                    <div className="d-none row">
                        <div className="col-md-3 col-xl-3 mx-auto py-2 ">
                            <img
                                src={this.state.branchImage || "http://placehold.it/150x150/?text=Logo"}
                                className="border rounded"
                                title="Selecionar Logo marca"
                                onClick={() => document.getElementById("branch-image").click()}
                                id='preview'
                                alt="a"
                                style={{
                                    cursor: "pointer",
                                    maxHeight: "93px",
                                    maxWidth: "150px"
                                }}
                            />
                            <input
                                onChange={this.setBrancImage}
                                accept="image/*"
                                type="file"
                                name="branch-image"
                                id="branch-image"
                                className="my-2 d-none" />
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-md-6 col-lg-6 col-xs-12">
                            <div className="mb-2 p-1 border border-primary" >
                                <label htmlFor="">CNPJ</label>
                                <p style={fontStyle} className="p-0 m-0">
                                    <strong>{this.state.company.cnpj}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Inscrição Estadual</label>
                                <p style={fontStyle} className="p-0 m-0">
                                    <strong>{this.state.company.state_registry}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="mb-2 p-1 border border-primary">
                        <label htmlFor="">Razão Social</label>
                        <p className="p-0 m-0">
                            <strong>{this.state.company.name}</strong>
                        </p>
                    </div>
                    <div className={`mb-2 p-1 border border-${this.state.company.fancy_name ? "primary" : "danger"}`}>
                        <label htmlFor="">Nome fantasia <EditField click={this.openModalEditFild} name="fancy_name" /></label>
                        <p className="p-0 m-0">
                            <strong>{this.state.company.fancy_name}</strong>
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-lg-6 col-xs-12">
                            <div className={`mb-2 p-1 border border-${this.state.company.email ? "primary" : "danger"}`}>
                                <label htmlFor="">Email <EditField click={this.openModalEditFild} name="email" /></label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.email}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xs-12">
                            <div className={`mb-2 p-1 border border-${this.state.company.phone_number ? "primary" : "danger"}`}>
                                <label htmlFor="">Telefone <EditField click={this.openModalEditFild} name="phone_number" /></label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.phone_number}</strong>
                                </p>
                            </div></div>
                    </div>
                    <div className="mb-2 p-1 border border-primary">
                        <label htmlFor="">Atividade Principal</label>
                        <p className="p-0 m-0">
                            <strong>
                                {
                                    this.state.company.cnae ?
                                        this.state.company.cnae.description
                                        : "n/a"
                                } - {
                                    this.state.company.cnae ?
                                        this.state.company.cnae.code
                                        : "n/a"
                                }
                            </strong>
                        </p>
                    </div>
                    <hr />
                    {!this.state.company.third_party ? <SefazInformation data={this.state.company} /> : <div />}
                    <p className="lead">
                        Endereço
                    </p>
                    <div className="row">
                        <div className="col-md-5 col-lg-5 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Endereço</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.address}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-5 col-lg-5 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Bairro</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.district}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-2 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Número</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.street_number}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5 col-lg-5 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">CEP</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.postal_code}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-5 col-lg-5 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Municipio</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.city}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-2 col-xs-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Estado</label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.state}</strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="mb-2 p-1 border border-primary">
                                <label htmlFor="">Complemento <EditField click={this.openModalEditFild} name="complement" /></label>
                                <p className="p-0 m-0">
                                    <strong>{this.state.company.complement}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <p className="lead">
                        Vencimento deste certificado digital
                    </p>
                    <p>{this.state.company.digital_certificate_info.expire_at}</p>
                    <Button
                        disabled={this.props.loading}
                        onClick={this.uploadWithRegister} size="lg">
                        Tudo certo. Podemos cadastar!
                     </Button>
                </Modal.Body>
                <Modal.Footer>
                    <p onClick={this.openDialogCloseModal} className="text-info" style={{ cursor: "pointer" }}>
                        <strong>
                            Prosseguir com o cadastro manual
                        </strong>
                    </p>

                </Modal.Footer>
            </Modal>
            <Modal show={this.state.modalDialog}>
                <Modal.Header>
                    <h2>Prosseguir com o cadastro manual?</h2>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Button className="mb-2" block onClick={this.closeModal}>
                        Sim, presseguir manualmente.
                        </Button>
                    <Button block>
                        Não, faça a importação automática.
                    </Button>
                </Modal.Body>
            </Modal>
            <Modal show={this.state.modaInformation} onHide={_ => this.setState({ ...this, modaInformation: false, message: '' })}>
                <Modal.Header closeButton>
                    <h2>{this.state.modalInforHeader}</h2>
                </Modal.Header>
                <Modal.Body>
                    <p className="lead">
                        {this.state.message}
                    </p>
                    <Button onClick={this.closeModal}>OK</Button>
                </Modal.Body>
            </Modal>
            <Modal show={this.state.modalEditField} onHide={this.closeModalEditFild}>
                <Modal.Header closeButton>
                    <h3>
                        Editar Campo
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <FormControl
                        onChange={this.changeField}
                        value={this.state.fieldInputValue} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.saveModalEditFild}>
                        Confirmar
                    </Button>
                    <Button onClick={this.closeModalEditFild}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }

    componentWillUnmount() { }
}

function EditField(props) {
    function click() {
        props.click(props.name)
    }
    return <i style={{ cursor: "pointer" }} onClick={click} className="fas fa-edit text-primary ml-2"></i>
}

function NFeStatus(props) {
    const textStyle = props.nfeSituation.enabled_to_emit_nfe ? "text-info" : "text-danger"
    let redirectUrl = "https://otimizeseunegocio.com/gestao-organizacao/mei-descubra-como-emitir-nota-fiscal-no-seu-estado/"
    if (props.state === "SP") {
        redirectUrl = "https://otimizeseunegocio.com/gestao-organizacao/nfe-mei-sp/"
    }

    if (props.nfeSituation.enabled_to_emit_nfe) {
        return <p className={`p-0 m-0 ${textStyle}`}>
            <strong>Habilitado para emissão de NF-e</strong>
        </p>
    } else {
        return <div>
            <p className={`p-0 m-0 ${textStyle}`}>
                <strong>Não habilitado para emissão de NF-e</strong>
            </p>
            <p className="p-0 m-0">Se você estiver com dificuldades em relação ao  credenciamento, clique <a href={redirectUrl} target="_blank" rel="noopener noreferrer">aqui</a> e acesse as regras de credenciamento do seu estado.</p>
            {
                !props.nfeSituation.nfe_mei_allowed
                    ? <div className="text-danger py-1">
                        <small>
                            <strong>ATENÇÃO!</strong> O ESTADO <strong className="">({props.state})</strong> NÂO PERMITE NF-e para MEI
                        </small>
                    </div>
                    : null
            }
            <div>
                <small>
                    OBS 1: Você pode continuar com o seu cadastro enquanto aguarda o credenciamento.
                </small>
            </div>
            <div>
                <small>
                    OBS 2: Se você realizou o credenciamento nas últimas horas, é comum que o processo demore até 1 dia últil.
                </small>
            </div>
        </div>
    }
}

function SefazInformation(props) {
    return <React.Fragment>
        <p className="lead">
            Informações SEFAZ
        </p>
        <div className="row">
            <div className="col-md-6 col-lg-6 col-xs-12">
                <div className="mb-2 p-1 border border-primary">
                    <label htmlFor="">Situação do contribuinte</label>
                    <p className={`p-0 m-0 text-${ props.data.sefaz_situation.status ? "info" : "danger"}`}>
                        <strong>
                            {
                                props.data.sefaz_situation && props.data.sefaz_situation.status ?
                                    "Habilitado" : "Não habilitado"
                            }
                        </strong>
                    </p>
                </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xs-12">
                <div className="mb-2 p-1 border border-primary">
                    <label htmlFor="">Credenciamento para emissão NF-e</label>

                    <NFeStatus state={props.data.state} nfeSituation={props.data.sefaz_situation.nfe_situation}/>

                </div>
            </div>
        </div>
        <hr />
    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setBasePersonName,
    setBasePersonEmail,
    setBasePersonPhoneNumber,

    setFancyName, setStateRegistry,
    setPersonDoc,

    setPostalCode,
    setStreetNumber,
    setComplement,
    setStateLocation,
    setCityLocation,
    setStreet,
    setDistrict,
    setCreateNewBranchStep
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ImportCertificate)


// WEBPACK FOOTER //
// ./src/components/pages/branches/create/importCertificate/index.jsx